export default __webpack_public_path__ + "static/media/grohn-logo.0851b7b7.png";